import { styled } from "@mui/material/styles";

export const StorageAccountsMaintenanceGrid = styled("div")(() => ({
  padding: "24px 32px",
  display: "flex",
  flexDirection: "row",
}));

export const StorageAccountTotalContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  color: "#667085",
  fontSize: "14px",
  fontFamily: "Manrope",
  fontWeight: 600,
  lineHeight: "24px",
}));

export const StorageAccountTotalText = styled("span")(() => ({
  color: "#1D2939",
  fontSize: "16px",
  fontFamily: "Manrope",
  fontWeight: 700,
  lineHeight: "150%",
}));

export const StorageAccountValue = styled("span")(() => ({
  color: "#308CDB",
  fontSize: "14px",
  fontFamily: "Manrope",
  fontWeight: 600,
  lineHeight: "24px",
}));
